import React from 'react';
import PropTypes from 'prop-types';
import ActivePokemon from '../ActivePokemon';
import BenchSlot from '../Bench/BenchSlot';
import Deck from '../Deck';
import DiscardPile from '../DiscardPile';
import PrizeSlot from '../Prizes/PrizeSlot';
import { BENCH_POSITIONS, PRIZE_POSITIONS } from './layout';
import { Active, BenchRow, Front, Piles, PrizeGrid, Side, Table, TableDivider } from './styled';

/** One player's side: prizes, active Pokémon and piles in front, the bench behind. */
const TableSide = ({ userId, opponent }) => (
  <Side $opponent={opponent}>
    <Front>
      <PrizeGrid aria-label="Prizes">
        {PRIZE_POSITIONS.map(position => <PrizeSlot key={position} userId={userId} position={position} />)}
      </PrizeGrid>
      <Active><ActivePokemon userId={userId} /></Active>
      <Piles>
        <Deck userId={userId} />
        <DiscardPile userId={userId} />
      </Piles>
    </Front>
    <BenchRow aria-label="Bench">
      {BENCH_POSITIONS.map(position => <BenchSlot key={position} userId={userId} position={position} />)}
    </BenchRow>
  </Side>
);

TableSide.propTypes = {
  userId: PropTypes.number.isRequired,
  opponent: PropTypes.bool,
};

/** The game laid out for a phone screen: bigger cards, every card upright. */
const TableBoard = ({ playerId, opponentId }) => (
  <Table>
    <TableSide userId={opponentId} opponent />
    <TableDivider />
    <TableSide userId={playerId} />
  </Table>
);

TableBoard.propTypes = {
  playerId: PropTypes.number.isRequired,
  opponentId: PropTypes.number.isRequired,
};

export default TableBoard;
